/** Русские подписи стандартных элементов интерфейса */
export const russianLocale = {
    emptyMessage: 'Нет доступных вариантов',
    emptyFilterMessage: 'Ничего не найдено',
    emptySearchMessage: 'Ничего не найдено',
    emptySelectionMessage: 'Ничего не выбрано',
    searchMessage: 'Найдено вариантов: {0}',
    selectionMessage: 'Выбрано элементов: {0}',
    firstDayOfWeek: 1,
    dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
    dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: [
        'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
        'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
    ],
    monthNamesShort: [
        'янв', 'фев', 'мар', 'апр', 'май', 'июн',
        'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'
    ],
    today: 'Сегодня',
    clear: 'Очистить',
    chooseDate: 'Выбрать дату',
    chooseMonth: 'Выбрать месяц',
    chooseYear: 'Выбрать год',
    prevDecade: 'Предыдущее десятилетие',
    nextDecade: 'Следующее десятилетие',
    prevYear: 'Предыдущий год',
    nextYear: 'Следующий год',
    prevMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    prevHour: 'Предыдущий час',
    nextHour: 'Следующий час',
    prevMinute: 'Предыдущая минута',
    nextMinute: 'Следующая минута',
    prevSecond: 'Предыдущая секунда',
    nextSecond: 'Следующая секунда',
    otpLabel: 'Цифра кода подтверждения {0}',
    am: 'AM',
    pm: 'PM'
};
